module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row wtf"
  }, [_c('div', {
    staticClass: "cols s_24 m___8"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_name),
      expression: "client_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.field1.placeholder
    },
    domProps: {
      "value": (_vm.client_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "validation-error",
    attrs: {
      "error": _vm.showRequiredName
    }
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v(_vm._s(_vm.field1.validator))])])])]), _vm._v(" "), _c('div', {
    staticClass: "cols s_24 m___8"
  }, [_c('label', {
    staticClass: "phone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_phone),
      expression: "client_phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.field2.placeholder
    },
    domProps: {
      "value": (_vm.client_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "validation-error",
    attrs: {
      "error": _vm.showRequiredPhone
    }
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v(_vm._s(_vm.field2.validator))])])])]), _vm._v(" "), _c('div', {
    staticClass: "cols s_24 m___8"
  }, [_c('label', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_email),
      expression: "client_email"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.field3.placeholder
    },
    domProps: {
      "value": (_vm.client_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "validation-error",
    attrs: {
      "error": _vm.showRequiredEmail
    }
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v(_vm._s(_vm.field3.validator))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cols s_24"
  }, [_c('div', {
    staticClass: "text1"
  }, [_vm._v(_vm._s(_vm.data.text1))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cols s_24 m___5 l_9 l__8"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_skype),
      expression: "client_skype"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.field4.placeholder
    },
    domProps: {
      "value": (_vm.client_skype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_skype = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cols s_24 m___19 l_15 l__16"
  }, [_c('div', {
    staticClass: "checkboxes"
  }, [_vm._l((_vm.fields5_6), function(btn) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.place),
        expression: "place"
      }],
      attrs: {
        "type": "radio",
        "name": btn.name
      },
      domProps: {
        "value": btn.value,
        "checked": _vm._q(_vm.place, btn.value)
      },
      on: {
        "change": function($event) {
          _vm.place = btn.value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ok"
    }), _vm._v(" "), _c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(btn.text))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "validation-error",
    attrs: {
      "error": _vm.showRequiredPlace
    }
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v(_vm._s(_vm.data.place))])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row end"
  }, [_c('div', {
    staticClass: "cols s_24 m___6 l_8"
  }, [_c('div', {
    staticClass: "submit"
  }, [_c('button', {
    on: {
      "click": _vm.click
    }
  }, [_vm._v(_vm._s(_vm.data.button))])])])]), _vm._v(" "), _c('grecaptcha', {
    attrs: {
      "request": _vm.request,
      "payload": _vm.payload
    },
    on: {
      "SENDFORM": _vm.onRecaptchaSubmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7551b42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/bx24-demo.vue
// module id = 404
// module chunks = 14